import { createFileRoute } from "@tanstack/react-router";
import { LegacyStub } from "@/components/client/LegacyStub";

export const Route = createFileRoute("/client/vault/share")({
  head: () => ({
    meta: [
      { title: "Share Estate Documents — Command Center" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: () => (
    <LegacyStub
      eyebrow="Estate Sharing"
      title="Share estate documents securely"
      intro="Generate signed, expiring links so trustees and family can access the documents they need — and only those."
    />
  ),
});